import React from 'react';

function Term_procurement_account_dashboard() {
 
 const powerBiUrl = process.env.REACT_APP_TermProcurement_Account_Dashboard;
 //console.log("Project Dashboard",powerBiUrl)
  
  return (
    
      <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    
  );
}

export default  Term_procurement_account_dashboard;